import { render, staticRenderFns } from "./refer-user.vue?vue&type=template&id=7adc2809&"
import script from "./refer-user.vue?vue&type=script&lang=js&"
export * from "./refer-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports